import { DogCard } from "./dog-card";
import { SAMPLE_DOGS } from "./sample-dogs";

const [SAMPLE] = SAMPLE_DOGS;

export function SampleDogCard() {
    return (
        <DogCard
            variant="overlay"
            id="sample-listing"
            name={SAMPLE.name}
            imageUrl=""
            breedNames={[SAMPLE.breed]}
            priceRange={{ min: 1500, max: 2500, currency: "USD" }}
            distanceMiles={SAMPLE.distanceMiles}
        />
    );
}
